import { ITextEditorFile } from "tir-pm-texteditor-file";
import { TaskFileModel } from "../../../models";
import { FilePreviewAccessEnum } from "tir-pm-file-preview";

export const mapToEditorFile = (taskFile: TaskFileModel): ITextEditorFile => ({
  FileId: taskFile.Id,
  Url: taskFile.Url,
  Name: taskFile.Name,
  Size: taskFile.Size,
  DateUpload: taskFile.DateUpload,
  Progress: taskFile.UploadProgress,
  VideoPreviewUrl: taskFile.VideoPreviewUrl,
  User: {
    Id: taskFile.User.Id,
    FirstName: taskFile.User.FirstName,
    LastName: taskFile.User.LastName,
    MiddleName: taskFile.User.MiddleName,
    AvatarColor: taskFile.User.AvatarColor,
    Image: taskFile.User.ImageUrl,
  },
  Accesses: taskFile.IsSendingLastChunk ? [] : [FilePreviewAccessEnum.Remove],
  IsProccessing: taskFile.IsProccessing,
});
